import { Theme } from '@mui/material';

export const getSeverityColors = (theme: Theme) => ({
  error: {
    color: theme.custom.status.error.selected,
    iconColor: theme.palette.error.main,
    textColor: theme.palette.error.light
  },
  warning: {
    color: theme.custom.status.warning.selected,
    iconColor: theme.palette.warning.main,
    textColor: theme.palette.warning.light
  },
  secondary: {
    color: theme.custom.status.secondary.selected,
    iconColor: theme.palette.secondary.main,
    textColor: theme.palette.secondary.light
  },
  success: {
    color: theme.custom.status.success.selected,
    iconColor: theme.palette.success.main,
    textColor: theme.palette.success.light
  }
});
